function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1 1.25h-4.2c-3.91 0-5.65 1.74-5.65 5.65v.35H6.9c-3.91 0-5.65 1.74-5.65 5.65v4.2c0 3.91 1.74 5.65 5.65 5.65h4.2c3.91 0 5.65-1.74 5.65-5.65v-.35h.35c3.91 0 5.65-1.74 5.65-5.65V6.9c0-3.91-1.74-5.65-5.65-5.65zm-6 6H8.75V6.9c0-3.1 1.05-4.15 4.15-4.15h4.2c3.1 0 4.15 1.05 4.15 4.15v4.2c0 3.1-1.05 4.15-4.15 4.15h-.35V12.9c0-3.91-1.74-5.65-5.65-5.65zm4.15 5.65v4.2c0 3.1-1.05 4.15-4.15 4.15H6.9c-3.1 0-4.15-1.05-4.15-4.15v-4.2c0-3.1 1.05-4.15 4.15-4.15h4.2c3.1 0 4.15 1.05 4.15 4.15zM7.5 17.48c.15.15.34.22.53.22s.38-.08.52-.22l3.9-3.89c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0l-3.36 3.36-1.42-1.42a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06l1.95 1.95z"
});

var SvgSelectAll = function SvgSelectAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgSelectAll;